<div class="wrap">
  <div class="offer_details_desktop">
    <div class="img_tags" #scrollDesktop>
      <div class="images">
        <div *ngIf="carousel.length === 1" class="mainPicture">
          <img [src]="carousel[0].src">
        </div>


        <div class="slideshow-container" *ngIf="carousel.length > 1">
          <div class="mySlides fade" *ngFor="let img of carousel; let i = index"
            [ngClass]="img.selected ? '': 'hidden'">
            <div class="numbertext">{{i + 1}} / {{carousel.length}}</div>
            <img [src]="img.src">
          </div>

          <a class="prev" (click)="plusSlides(-1)">❮</a>
          <a class="next" (click)="plusSlides(1)">❯</a>
        </div>

        <div class="photo_experience" *ngIf="offer?.photoExperience">
          <p>{{offer?.photoExperience}}</p>
        </div>
        <div class="infos_sub_img">
          <div class="infos">
            <div class="icon">
              <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
            </div>
            {{offer?.duration? offer?.duration : 'NC'}}
          </div>
          <div class="infos">
            <div class="icon">
              <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
            </div>
            <p>
              {{offer?.practicePlace? offer?.practicePlace: 'NC'}}
            </p>
          </div>
        </div>

      </div>

      <div class="club">
        <div class="logo_club">
          <img [src]="getImg()" alt="">

        </div>
        <div class="infos_club">
          Offre proposée par <strong>{{offer?.clubName}}</strong>

          <div class="overview_club_content">
            <span>
              <fa-icon [icon]="getFaIcon('faPhone')" appChangeColorTheme attribute="color"></fa-icon>
              <a href="tel:{{club?.phoneNumber}}">{{club?.phoneNumber}}</a>
            </span>
            <span>
              <fa-icon [icon]="getFaIcon('faEnvelope')" appChangeColorTheme attribute="color"></fa-icon>
              <a href="mailto:{{club?.mail}}">{{club?.mail}}</a>
            </span>
          </div>

          <p class="redirect_file" *ngIf="this.files?.length" (click)="scrollTo(scrollDesktop, desktopPosition)">
            <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color"></fa-icon> Liste des fichiers
            ({{files?.length}})
          </p>
        </div>


      </div>

      <div class="tags">
        <div class="tag" *ngFor="let t of tags" [style.background-color]="getValueColorTag(t)"> {{t?.tagName}}</div>
      </div>

      <div class="offer_sessions" *ngIf="offer?.hasSession && !offer?.isExternalOffer">
        <h4>Sessions de l'offre:</h4>

        <div class="sessions_list" *ngIf="sessions?.length">

          <div class="session_list_header" appChangeColorTheme attribute="bgc" rgba="0.1">
            <div>Label</div>
            <div>Début</div>
            <div>Fin</div>
            <div class="text_center trainee_reduce">Places</div>
          </div>

          <ngx-simplebar class="session_list_content">

            <ng-container *ngFor="let s of sessions">
              <div class="session_line" *ngIf="s.sessionStartDate !== '0001-01-01T00:00:00Z'">
                <div>{{s.dateLib}}</div>
                <div>
                  {{ s.sessionStartDate !== '0001-01-01T00:00:00Z' ? (s.sessionStartDate | date: 'shortDate':'UTC') :
                  '-'}}
                </div>
                <div>{{ s.sessionEndDate !== '0001-01-01T00:00:00Z' ? (s.sessionEndDate | date: 'shortDate':'UTC') :
                  '-'}}
                </div>
                <div class="text_center session_quantity">
                  <span *ngIf="s.bookedSessionTrainees !==s.quantity">{{s.quantity - s.bookedSessionTrainees}}</span>
                  <span *ngIf="s.bookedSessionTrainees ===s.quantity" class="session_complete">Complète</span>
                </div>
                <div class="text_center">
                  <!-- <fa-icon [icon]="faPen"></fa-icon> -->
                </div>
              </div>
            </ng-container>

          </ngx-simplebar>

        </div>

        <div class="no_session" *ngIf="!sessions?.length">
          <div>
            <p>Il n'y a aucune session pour cette offre.</p>
            <!-- <button>Ajouter une session</button> -->
          </div>
        </div>
      </div>

      <ul class="files" [style.opacity]="this.files?.length ? 1 : 0" #desktopPosition appChangeColorTheme
        attribute="bgc" rgba="0.1">
        <h4>
          <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color" [style.margin-right.px]="10">
          </fa-icon> Liste
          des fichiers
        </h4>

        <li *ngFor="let f of files">
          <span>{{f.fileName}}</span>

          <div class="btn_action">
            <fa-icon [icon]="getFaIcon('faDownload')" [matTooltip]="'Télécharger'"
              (click)="downloadFile(f.offerKey, f.offerFileKey,f.fileName )" appChangeColorTheme attribute="color">
            </fa-icon>
          </div>
        </li>

      </ul>

    </div>

    <div class="offer_details">
      <!-- <button appChangeColorTheme attribute="bgc" class="faQuestionCircle" (click)="openDialogHelp()" disabled [style.opacity]=".4">
        <fa-icon [icon]="getFaIcon('faQuestionCircle')"></fa-icon>
         Aide
      </button> -->
      <div class="header">
        <h2>{{offer?.offerName}}</h2>
        <!-- <div class="price">{{offer?.price}}€</div> -->
      </div>

      <div class="description">
        <!-- <h3>Description</h3> -->
        <p appChangeColorTheme attribute="color" [innerHtml]="offer?.description"></p>
      </div>

      <div class="action_offer">
        <div class="add_wish" (click)="router.url !=='/admin/offers' ?  addOrDeleteToMyWish(offer, $event) : null"
          appChangeColorTheme attribute="bgc">
          <fa-icon [icon]="router.url !=='/admin/offers' ? isInMyWishes(offer?.offerKey) : faHeartEmpty"
            [style.color]="router.url !=='/admin/offers' ? getColorOfHeart(offer?.offerKey):'#2c296d'">
          </fa-icon>
          <span>{{isInMyWishesBoolean(offer?.offerKey) ? 'Ajouté à mes favoris' : 'Ajouter à mes favoris' }}</span>
        </div>

        <div [ngClass]="{add_basket: !isInBasket(), added_basket: isInBasket()}"
          (click)="!isInBasket() ?addOrDeleteToMyShoppingBag(offer): null" *ngIf="!offer?.isExternalOffer"
          appChangeColorTheme attribute="bgc">
          <fa-icon [icon]="isInBasket() ? getFaIcon('faCheck') :  getFaIcon('faShoppingBasket')"></fa-icon>
          <ng-container [ngSwitch]="getUnivers()">
            <div *ngSwitchCase="true">{{ isInBasket()? "Inscrit" : "S'incrire" }}</div>
            <div *ngSwitchDefault>{{ isInBasket()? "Ajouté au panier" : "Ajouter au panier" }}</div>
          </ng-container>
        </div>

        <a [href]="offer?.offerClubURL" target="_blank" class="add_basket" *ngIf="offer?.isExternalOffer">

          <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>

          <ng-container [ngSwitch]="getUnivers()">
            <div *ngSwitchCase="true">S'incrire sur le site du club</div>
            <div *ngSwitchDefault>Acheter sur le site du club</div>
          </ng-container>
        </a>

      </div>

      <ul class="precision_offer" style="--numbOfRows:var(--numbOfRows){{getNumberOfRow()}}">

        <li *ngIf="offer?.customerPromise" appChangeColorTheme attribute="bgc" rgba='0.1'>
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faGrinAlt')" appChangeColorTheme attribute="color"></fa-icon>
            Ce que vous allez vivre
          </div>
          <span appChangeColorTheme attribute="color" [innerHtml]="offer?.customerPromise || 'NC'"></span>
        </li>

        <li *ngIf="offer?.informations" appChangeColorTheme attribute="bgc" rgba='0.1'>
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faInfoCircle')" appChangeColorTheme attribute="color"></fa-icon>
            Descriptif de l'activité
          </div>
          <span appChangeColorTheme attribute="color" id="informations_offer_details" [innerHtml]="offer?.informations">
          </span>
        </li>

        <li *ngIf="offer?.practicePlace" appChangeColorTheme attribute="bgc" rgba='0.1'>
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faMapMarkedAlt')" appChangeColorTheme attribute="color"></fa-icon>
            Lieu de pratique
          </div>
          <span appChangeColorTheme attribute="color" *ngIf="offer.fullPracticePlace">
            {{offer.fullPracticePlace?.label + ' - '}}
            <ng-container *ngIf="offer.fullPracticePlace?.country">
              {{offer.fullPracticePlace?.country}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.region">
              {{offer.fullPracticePlace?.region}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.department">
              {{offer.fullPracticePlace?.department}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.city">
              {{offer.fullPracticePlace?.city}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.postalCode">
              {{offer.fullPracticePlace?.postalCode}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.address">
              {{offer.fullPracticePlace?.address}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.box">
              {{offer.fullPracticePlace?.box}}
            </ng-container>
          </span>
        </li>

        <li *ngIf="offer?.services" appChangeColorTheme attribute="bgc" rgba='0.1'>
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faLifeRing')" appChangeColorTheme attribute="color"></fa-icon>
            Nos conseils pratiques pour retirer tout le bénéfice de l’expérience
          </div>
          <span appChangeColorTheme attribute="color" [innerHTML]="offer?.services || 'NC'"></span>
        </li>

        <li *ngIf="offer?.price" appChangeColorTheme attribute="bgc" rgba='0.1'>
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faEuroSign')" appChangeColorTheme attribute="color"></fa-icon>
            Prix
          </div>
          <span appChangeColorTheme attribute="color">{{offer?.price || "NC"}}</span>
        </li>



        <li *ngIf="offer?.duration" appChangeColorTheme attribute="bgc" rgba='0.1'>
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faClockSolid')" appChangeColorTheme attribute="color"></fa-icon>
            Durée
          </div>
          <span appChangeColorTheme attribute="color">{{offer?.duration || "NC"}}</span>
        </li>

        <li *ngIf="offer?.environment" appChangeColorTheme attribute="bgc" rgba='0.1'>
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faWater')" appChangeColorTheme attribute="color"></fa-icon>
            Comment compléter agréablement votre séjour ?
          </div>
          <span appChangeColorTheme attribute="color" [innerHtml]="offer?.environment || 'NC'"></span>
        </li>

        <li *ngIf="offer?.prerequisites" appChangeColorTheme attribute="bgc" rgba='0.1'>
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faMedal')" appChangeColorTheme attribute="color"></fa-icon>
            Prérequis
          </div>
          <span appChangeColorTheme attribute="color" [innerHTML]="offer?.prerequisites || 'NC'"></span>
        </li>

        <li *ngIf="offer?.openingPeriod" appChangeColorTheme attribute="bgc" rgba='0.1'>
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faCalendar')" appChangeColorTheme attribute="color"></fa-icon>
            Période d'ouverture
          </div>
          <span appChangeColorTheme attribute="color">{{offer?.openingPeriod || "NC"}}</span>
        </li>

      </ul>

      <div class="action_offer" *ngIf="getNumberOfRow() >= 2">
        <div class="add_wish" (click)="router.url !=='/admin/offers' ?  addOrDeleteToMyWish(offer, $event) : null"
          appChangeColorTheme attribute="bgc">
          <fa-icon [icon]="router.url !=='/admin/offers' ? isInMyWishes(offer?.offerKey) : faHeartEmpty"
            [style.color]="router.url !=='/admin/offers' ? getColorOfHeart(offer?.offerKey):'#2c296d'">
          </fa-icon>
          <span>{{isInMyWishesBoolean(offer?.offerKey) ? 'Ajouté à mes favoris' : 'Ajouter à mes favoris' }}</span>
        </div>

        <div [ngClass]="{add_basket: !isInBasket(), added_basket: isInBasket()}"
          (click)="!isInBasket() ?addOrDeleteToMyShoppingBag(offer): null" *ngIf="!offer?.isExternalOffer"
          appChangeColorTheme attribute="bgc">
          <fa-icon [icon]="isInBasket() ? getFaIcon('faCheck') :  getFaIcon('faShoppingBasket')"></fa-icon>
          <ng-container [ngSwitch]="getUnivers()">
            <div *ngSwitchCase="true">{{ isInBasket()? "Inscrit" : "S'incrire" }}</div>
            <div *ngSwitchDefault>{{ isInBasket()? "Ajouté au panier" : "Ajouter au panier" }}</div>
          </ng-container>
        </div>

        <a [href]="offer?.offerClubURL" target="_blank" class="add_basket" *ngIf="offer?.isExternalOffer">

          <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>

          <ng-container [ngSwitch]="getUnivers()">
            <div *ngSwitchCase="true">S'incrire sur le site du club</div>
            <div *ngSwitchDefault>Acheter sur le site du club</div>
          </ng-container>
        </a>

      </div>

    </div>


  </div>

  <div class="offer_details_tablet" #scrollTablet>
    <!-- <button appChangeColorTheme attribute="bgc" class="faQuestionCircle" (click)="openDialogHelp()">
      <fa-icon [icon]="getFaIcon('faQuestionCircle')"></fa-icon>
       Aide
    </button> -->
    <div class="images">
      <!-- <img [src]="image"> -->
      <div *ngIf="carousel.length === 1" class="mainPicture">
        <img [src]="carousel[0].src">
      </div>


      <div class="slideshow-container" *ngIf="carousel.length > 1">
        <div class="mySlides fade" *ngFor="let img of carousel; let i = index" [ngClass]="img.selected ? '': 'hidden'">
          <div class="numbertext">{{i + 1}} / {{carousel.length}}</div>
          <img [src]="img.src">
        </div>

        <a class="prev" (click)="plusSlides(-1)">❮</a>
        <a class="next" (click)="plusSlides(1)">❯</a>
      </div>

      <div class="photo_experience" *ngIf="offer?.photoExperience">
        <p>{{offer?.photoExperience}}</p>
      </div>
      <div class="infos_sub_img">
        <div class="infos">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
          </div>
          {{offer?.duration? offer?.duration : 'NC'}}
        </div>
        <div class="infos">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
          </div>
          <p>
            {{offer?.practicePlace? offer?.practicePlace: 'NC'}}
          </p>
        </div>
      </div>

    </div>

    <div class="offer_details">

      <div class="header">
        <h2>{{offer?.offerName}}</h2>
        <!-- <div class="price">{{offer?.price}}</div> -->
      </div>

      <div class="description">
        <!-- <h3>Description</h3> -->
        <p appChangeColorTheme attribute="color" [innerHtml]="offer?.description"></p>
      </div>

      <div class="action_offer">

        <div class="add_wish" (click)="router.url !=='/admin/offers' ?  addOrDeleteToMyWish(offer, $event) : null"
          appChangeColorTheme attribute="bgc">
          <fa-icon [icon]="router.url !=='/admin/offers' ? isInMyWishes(offer?.offerKey) : faHeartEmpty"
            [style.color]="router.url !=='/admin/offers' ? getColorOfHeart(offer?.offerKey):'#2c296d'">
          </fa-icon>
          <span>{{isInMyWishesBoolean(offer?.offerKey) ? 'Ajouté à mes favoris' : 'Ajouter à mes favoris' }}</span>
        </div>


        <div [ngClass]="{add_basket: !isInBasket(), added_basket: isInBasket()}"
          (click)="!isInBasket() ?addOrDeleteToMyShoppingBag(offer): null" *ngIf="!offer?.isExternalOffer"
          appChangeColorTheme attribute="bgc">
          <fa-icon [icon]="isInBasket() ? getFaIcon('faCheck') :  getFaIcon('faShoppingBasket')"></fa-icon>
          <ng-container [ngSwitch]="getUnivers()">
            <div *ngSwitchCase="true">{{ isInBasket()? "Inscrit" : "S'incrire" }}</div>
            <div *ngSwitchDefault>{{ isInBasket()? "Ajouté au panier" : "Ajouter au panier" }}</div>
          </ng-container>
        </div>

        <a [href]="offer?.offerClubURL" target="_blank" class="add_basket" *ngIf="offer?.isExternalOffer">

          <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>
          Acheter sur le site du club
        </a>


      </div>

      <div class="club">

        <div class="logo_club">
          <img [src]="getImg()" alt="">
        </div>

        <div class="infos_club">
          Offre proposée par <strong>{{offer?.clubName}}</strong>

          <div class="overview_club_content">
            <span>
              <fa-icon [icon]="getFaIcon('faPhone')" appChangeColorTheme attribute="color"></fa-icon>
              <a href="tel:{{club?.phoneNumber}}">{{club?.phoneNumber}}</a>
            </span>
            <span>
              <fa-icon [icon]="getFaIcon('faEnvelope')" appChangeColorTheme attribute="color"></fa-icon>
              <a href="mailto:{{club?.mail}}">{{club?.mail}}</a>

            </span>
          </div>

          <p class="redirect_file" *ngIf="this.files?.length" (click)="scrollTo(scrollTablet, tabletPosition)">
            <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color"></fa-icon> Liste des fichiers
            ({{files?.length}})
          </p>

        </div>


      </div>

      <ul class="precision_offer">
        <li *ngIf="offer?.customerPromise" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faGrinAlt')" appChangeColorTheme attribute="color"></fa-icon>
            Ce que vous allez vivre
          </div>
          <span appChangeColorTheme attribute="color" [innerHtml]="offer?.customerPromise || 'NC'"></span>
        </li>

        <li *ngIf="offer?.informations" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faInfoCircle')" appChangeColorTheme attribute="color"></fa-icon>
            Descriptif de l'activité
          </div>
          <span appChangeColorTheme attribute="color" [innerHtml]="offer?.informations || 'NC'"></span>
        </li>

        <li *ngIf="offer?.practicePlace" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faMapMarkedAlt')" appChangeColorTheme attribute="color"></fa-icon>
            Lieu de pratique
          </div>
          <span appChangeColorTheme attribute="color" *ngIf="offer.fullPracticePlace">
            {{offer.fullPracticePlace?.label + ' - '}}
            <ng-container *ngIf="offer.fullPracticePlace?.country">
              {{offer.fullPracticePlace?.country}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.region">
              {{offer.fullPracticePlace?.region}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.department">
              {{offer.fullPracticePlace?.department}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.city">
              {{offer.fullPracticePlace?.city}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.postalCode">
              {{offer.fullPracticePlace?.postalCode}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.address">
              {{offer.fullPracticePlace?.address}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.box">
              {{offer.fullPracticePlace?.box}}
            </ng-container>
          </span>
        </li>

        <li *ngIf="offer?.services" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faLifeRing')" appChangeColorTheme attribute="color"></fa-icon>
            Nos conseils pratiques pour retirer tout le bénéfice de l’expérience
          </div>
          <span appChangeColorTheme attribute="color" [innerHtml]="offer?.services || 'NC'"></span>
        </li>

        <li *ngIf="offer?.price" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faEuroSign')" appChangeColorTheme attribute="color"></fa-icon>
            Prix
          </div>
          <span appChangeColorTheme attribute="color">{{offer?.price || "NC"}}</span>
        </li>



        <li *ngIf="offer?.duration" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faClockSolid')" appChangeColorTheme attribute="color"></fa-icon>
            Durée
          </div>
          <span appChangeColorTheme attribute="color">{{offer?.duration || "NC"}}</span>
        </li>

        <li *ngIf="offer?.environment" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faWater')" appChangeColorTheme attribute="color"></fa-icon>
            Environnement
          </div>
          <span appChangeColorTheme attribute="color" [innerHtml]="offer?.environment || 'NC'"></span>
        </li>

        <li *ngIf="offer?.prerequisites" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faMedal')" appChangeColorTheme attribute="color"></fa-icon>
            Prérequis
          </div>
          <span appChangeColorTheme attribute="color" [innerHtml]="offer?.prerequisites || 'NC'"></span>
        </li>

        <li *ngIf="offer?.openingPeriod" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faCalendar')" appChangeColorTheme attribute="color"></fa-icon>
            Période d'ouverture
          </div>
          <span appChangeColorTheme attribute="color">{{offer?.openingPeriod || "NC"}}</span>
        </li>


      </ul>

    </div>

    <div class="tags">
      <div class="tag" *ngFor="let t of offer?.tags" [style.background-color]="getValueColorTag(t)"> {{t?.tagName}}
      </div>
    </div>

    <div class="offer_sessions" *ngIf="offer?.hasSession && !offer?.isExternalOffer">
      <h4>Sessions de l'offre:</h4>

      <div class="sessions_list" *ngIf="sessions?.length">

        <div class="session_list_header" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div>Label</div>
          <div>Début</div>
          <div>Fin</div>
          <div class="text_center trainee_reduce">Places</div>
        </div>

        <ngx-simplebar class="session_list_content">

          <ng-container *ngFor="let s of sessions">
            <div class="session_line" *ngIf="s.sessionStartDate !== '0001-01-01T00:00:00Z'">
              <div>{{s.dateLib}}</div>
              <div>{{ s.sessionStartDate !== '0001-01-01T00:00:00Z' ? (s.sessionStartDate | date: 'shortDate':'UTC') :
                '-'}}
              </div>
              <div>{{ s.sessionEndDate !== '0001-01-01T00:00:00Z' ? (s.sessionEndDate | date: 'shortDate':'UTC') : '-'}}
              </div>
              <div class="text_center session_quantity">
                <span *ngIf="s.bookedSessionTrainees !==s.quantity">{{s.quantity - s.bookedSessionTrainees}}</span>
                <span *ngIf="s.bookedSessionTrainees ===s.quantity" class="session_complete">Complète</span>
              </div>
              <div class="text_center">
                <!-- <fa-icon [icon]="faPen"></fa-icon> -->
              </div>
            </div>
          </ng-container>

        </ngx-simplebar>

      </div>

      <div class="no_session" *ngIf="!sessions?.length">
        <div>
          <p>Il n'y a aucune session pour cette offre.</p>
          <!-- <button>Ajouter une session</button> -->
        </div>
      </div>
    </div>

    <ul class="files" [style.opacity]="this.files?.length ? 1 : 0" #tabletPosition appChangeColorTheme attribute="bgc"
      rgba="0.1">
      <h4>
        <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color" [style.margin-right.px]="10">
        </fa-icon> Liste des
        fichiers
      </h4>

      <li *ngFor="let f of files">
        <span>{{f.fileName}}</span>

        <div class="btn_action">
          <fa-icon [icon]="getFaIcon('faDownload')" [matTooltip]="'Télécharger'"
            (click)="downloadFile(f.offerKey, f.offerFileKey,f.fileName )" appChangeColorTheme attribute="color">
          </fa-icon>
        </div>
      </li>

    </ul>

  </div>

  <div class="offer_details_mobile" #scrollMobile>
    <!-- <button appChangeColorTheme attribute="bgc" class="faQuestionCircle" (click)="openDialogHelp()">
      <fa-icon [icon]="getFaIcon('faQuestionCircle')"></fa-icon>
       Aide
    </button> -->

    <div class="images">
      <div *ngIf="carousel.length === 1" class="mainPicture">
        <img [src]="carousel[0].src">
      </div>

      <div class="slideshow-container" *ngIf="carousel.length > 1">
        <div class="mySlides fade" *ngFor="let img of carousel; let i = index" [ngClass]="img.selected ? '': 'hidden'">
          <div class="numbertext">{{i + 1}} / {{carousel.length}}</div>
          <img [src]="img.src">
        </div>

        <a class="prev" (click)="plusSlides(-1)">❮</a>
        <a class="next" (click)="plusSlides(1)">❯</a>
      </div>

      <div class="photo_experience" *ngIf="offer?.photoExperience">
        <p>{{offer?.photoExperience}}</p>
      </div>
      <div class="infos_sub_img">
        <div class="infos">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
          </div>
          {{offer?.duration? offer?.duration : 'NC'}}
        </div>
        <div class="infos">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
          </div>
          <p>
            {{offer?.practicePlace? offer?.practicePlace: 'NC'}}
          </p>
        </div>
      </div>

    </div>

    <div class="offer_details">

      <div class="header">
        <h2>{{offer?.offerName}}</h2>
        <!-- <div class="price">{{offer?.price}}</div> -->
      </div>

      <div class="description">
        <!-- <h3>Description</h3> -->
        <p appChangeColorTheme attribute="color" [innerHtml]="offer?.description"></p>
      </div>

      <div class="action_offer">

        <div [ngClass]="{add_basket: !isInBasket(), added_basket: isInBasket()}"
          (click)="!isInBasket() ?addOrDeleteToMyShoppingBag(offer): null" *ngIf="!offer?.isExternalOffer"
          appChangeColorTheme attribute="bgc">
          <fa-icon [icon]="isInBasket() ? getFaIcon('faCheck') :  getFaIcon('faShoppingBasket')"></fa-icon>
          <ng-container [ngSwitch]="getUnivers()">
            <div *ngSwitchCase="true">{{ isInBasket()? "Inscrit" : "S'incrire" }}</div>
            <div *ngSwitchDefault>{{ isInBasket()? "Ajouté au panier" : "Ajouter au panier" }}</div>
          </ng-container>
        </div>

        <a [href]="offer?.offerClubURL" target="_blank" class="add_basket" *ngIf="offer?.isExternalOffer">

          <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>
          Acheter sur le site du club

        </a>

        <div class="add_wish" (click)="router.url !=='/admin/offers' ?  addOrDeleteToMyWish(offer, $event) : null"
          appChangeColorTheme attribute="bgc">
          <fa-icon [icon]="router.url !=='/admin/offers' ? isInMyWishes(offer?.offerKey) : faHeartEmpty"
            [style.color]="router.url !=='/admin/offers' ? getColorOfHeart(offer?.offerKey):'#2c296d'">
          </fa-icon>
          <span>{{isInMyWishesBoolean(offer?.offerKey) ? 'Ajouté à mes favoris' : 'Ajouter à mes favoris' }}</span>
        </div>

      </div>

      <div class="club">
        <div class="logo_club">
          <img [src]="getImg()" alt="logo_club">
        </div>

        <div class="infos_club">
          Offre proposée par <strong>{{offer?.clubName}}</strong>

          <div class="overview_club_content">
            <span>
              <fa-icon [icon]="getFaIcon('faPhone')" appChangeColorTheme attribute="color"></fa-icon>
              <a href="tel:{{club?.phoneNumber}}">{{club?.phoneNumber}}</a>
            </span>
            <span>
              <fa-icon [icon]="getFaIcon('faEnvelope')" appChangeColorTheme attribute="color"></fa-icon>
              <a href="mailto:{{club?.mail}}">{{club?.mail}}</a>

            </span>
          </div>

          <p class="redirect_file" *ngIf="this.files?.length" (click)="scrollTo(scrollMobile, mobilePosition)">
            <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color"></fa-icon> Liste des fichiers
            ({{files?.length}})
          </p>
        </div>

      </div>

      <ul class="precision_offer">
        <li *ngIf="offer?.customerPromise" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faGrinAlt')" appChangeColorTheme attribute="color"></fa-icon>
            Ce que vous allez vivre
          </div>
          <span appChangeColorTheme attribute="color" [innerHtml]="offer?.customerPromise || 'NC'"></span>
        </li>

        <li *ngIf="offer?.informations" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faInfoCircle')" appChangeColorTheme attribute="color"></fa-icon>
            Descriptif de l'activité
          </div>
          <span appChangeColorTheme attribute="color" [innerHtml]="offer?.informations || 'NC'"></span>
        </li>

        <li *ngIf="offer?.practicePlace" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faMapMarkedAlt')" appChangeColorTheme attribute="color"></fa-icon>
            Lieu de pratique
          </div>
          <span appChangeColorTheme attribute="color" *ngIf="offer.fullPracticePlace">
            <ng-container *ngIf="offer.fullPracticePlace?.label">
              {{offer.fullPracticePlace?.label}} -
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.country">
              {{offer.fullPracticePlace?.country}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.region">
              {{offer.fullPracticePlace?.region}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.department">
              {{offer.fullPracticePlace?.department}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.city">
              {{offer.fullPracticePlace?.city}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.postalCode">
              {{offer.fullPracticePlace?.postalCode}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.address">
              {{offer.fullPracticePlace?.address}}
            </ng-container>
            <ng-container *ngIf="offer.fullPracticePlace?.box">
              {{offer.fullPracticePlace?.box}}
            </ng-container>
          </span>
        </li>

        <li *ngIf="offer?.services" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faLifeRing')" appChangeColorTheme attribute="color"></fa-icon>
            Nos conseils pratiques pour retirer tout le bénéfice de l’expérience
          </div>
          <span appChangeColorTheme attribute="color" [innerHTML]="offer?.services || 'NC'"></span>
        </li>

        <li *ngIf="offer?.price" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faEuroSign')" appChangeColorTheme attribute="color"></fa-icon>
            Prix
          </div>
          <span appChangeColorTheme attribute="color">{{offer?.price || "NC"}}</span>
        </li>



        <li *ngIf="offer?.duration" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faClockSolid')" appChangeColorTheme attribute="color"></fa-icon>
            Durée
          </div>
          <span appChangeColorTheme attribute="color">{{offer?.duration || "NC"}}</span>
        </li>

        <li *ngIf="offer?.environment" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faWater')" appChangeColorTheme attribute="color"></fa-icon>
            Environnement
          </div>
          <span appChangeColorTheme attribute="color" [innerHtml]="offer?.environment || 'NC'"></span>
        </li>

        <li *ngIf="offer?.prerequisites" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faMedal')" appChangeColorTheme attribute="color"></fa-icon>
            Prérequis
          </div>
          <span appChangeColorTheme attribute="color" [innerHTML]="offer?.prerequisites || 'NC'"></span>
        </li>

        <li *ngIf="offer?.openingPeriod" appChangeColorTheme attribute="bgc" rgba="0.1">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faCalendar')" appChangeColorTheme attribute="color"></fa-icon>
            Période d'ouverture
          </div>
          <span appChangeColorTheme attribute="color">{{offer?.openingPeriod || "NC"}}</span>
        </li>


      </ul>

    </div>

    <div class="tags">
      <div class="tag" *ngFor="let t of tags" [style.background-color]="getValueColorTag(t)"> {{t?.tagName}}</div>
    </div>

    <div class="offer_sessions" *ngIf="offer?.hasSession && !offer?.isExternalOffer">
      <h4>Sessions de l'offre:</h4>

      <div class="sessions_list" *ngIf="sessions?.length">

        <ngx-simplebar class="session_list_content">

          <ng-container *ngFor="let s of sessions">
            <div class="session_line" *ngIf="s.sessionStartDate !== '0001-01-01T00:00:00Z'" appChangeColorTheme
              attribute="bgc" rgba="0.2">
              <div class="label_nbr_place">
                <div>{{s.dateLib}}</div>
                <span>nbr de places:</span>
                <div class="text_center session_quantity">
                  <span *ngIf="s.bookedSessionTrainees !==s.quantity"> {{s.quantity - s.bookedSessionTrainees}}</span>
                  <span *ngIf="s.bookedSessionTrainees ===s.quantity" class="session_complete">Complète</span>
                </div>
              </div>
              <div class="session_date">
                <div>
                  {{ s.sessionStartDate !== '0001-01-01T00:00:00Z' ? (s.sessionStartDate | date: 'shortDate':'UTC') :
                  '-'}}
                </div>
                -
                <div>{{ s.sessionEndDate !== '0001-01-01T00:00:00Z' ? (s.sessionEndDate | date: 'shortDate':'UTC') :
                  '-'}}
                </div>
              </div>


            </div>
          </ng-container>

        </ngx-simplebar>

      </div>

      <div class="no_session" *ngIf="!sessions?.length">
        <div>
          <p>Il n'y a aucune session pour cette offre.</p>
        </div>
      </div>
    </div>

    <ul class="files" [style.opacity]="this.files?.length ? 1 : 0" #mobilePosition appChangeColorTheme attribute="bgc"
      rgba="0.1">
      <h4>
        <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color" [style.margin-right.px]="10">
        </fa-icon> Liste des
        fichiers
      </h4>

      <li *ngFor="let f of files">
        <span>{{f.fileName}}</span>

        <div class="btn_action">
          <fa-icon [icon]="getFaIcon('faDownload')" [matTooltip]="'Télécharger'"
            (click)="downloadFile(f.offerKey, f.offerFileKey,f.fileName )" appChangeColorTheme attribute="color">
          </fa-icon>
        </div>
      </li>

    </ul>

  </div>

</div>